module.exports = __webpack_public_path__ + "static/media/logo-circle-min.3cc2baca.png";